import { TableCell, Rating, Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const DataTableColumn = ({ row, column, value }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (column.id === "name") {
      navigate(`/ServiceDetails/${row["id"]}`);
    }
  };

  return (
    <TableCell
      onClick={handleNavigation}
      key={column.id}
      style={{
        border: "1px solid #00000080",
        cursor: column.id === "name" ? "pointer" : "default",
      }}
    >
      {column.id === "name" ? (
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {value}
          </Typography>
          <Rating
            value={row["avg"] || 0} // Use the avg from row data
            precision={0.5} // Allows half-star ratings
            readOnly
            size="small"
            sx={{
              "& .MuiRating-icon": {
                fontSize: "1rem", // Slightly smaller than your original
              },
            }}
          />
        </Box>
      ) : typeof value === "string" ? (
        value.slice(0, 50)
      ) : (
        value
      )}
    </TableCell>
  );
};

export default DataTableColumn;
